import storage from '../../utils/storage';
import {
    ApiGetClientEntityId,
    ApiRegionVenues
} from "../../apiService/Core/Apicall";

import { setRegion } from "../../global/config/Reducer/RegionSlice";
import { setallclientEntityIds } from "../../global/config/Reducer/WholeGroupSlice";
import { json } from 'stream/consumers';
import { useEffect } from 'react';
import { error } from 'console';

export const restoreSession = async (
    dispatch: any,
    navigate: any
) => {

    // const tempclientGroupName = (window.location.hostname.includes('aldi')) ? "ALDI" : window.location.hostname.includes('blooms') ? "BLOOMS" : "MM"

    try {
        const token = localStorage.getItem("token");
        const ActiveTask: any = localStorage.getItem("ActiveTask");
        const clientId = localStorage.getItem("clientId");
        const userRole = localStorage.getItem("userRole");
        const userData: any = JSON.parse(localStorage.getItem("userData") || "{}")
        const userOtherData: any = JSON.parse(localStorage.getItem("userOtherData") || "{}")

        if (!token) return false;
        // Restore token back to session storage
        storage.setItem("token", token);
        storage.setItem("ActiveTask", ActiveTask);

        const clientGroupName =
            localStorage.getItem("ClientGroupName");

        if (userRole) {
            storage.setItem("userRole", userRole);
        }

        if (clientGroupName) {
            storage.setItem(
                "ClientGroupName",
                clientGroupName
            );
        }
        if (clientId) {
            storage.setItem(
                "clientId",
                clientId
            );
        }

        // CLIENT ADMIN FLOW
        // if (userRole === "clientadmin") {
        //     const clientId = localStorage.getItem("clientId");

        //     if (clientId) {
        //         storage.setItem("clientId", clientId);

        //         const response2 =
        //             await ApiGetClientEntityId(clientId);
        //         console.log("Respnse of resession", response2.data)
        //         storage.setItem(
        //             "ratingJson",
        //             response2.data[0][0]?.ratingJson
        //         );

        //         storage.setItem(
        //             "clientEntityId",
        //             response2.data[0][0].clientEntityId
        //         );

        //         storage.setItem(
        //             "clientEntityName",
        //             response2.data[0][0].entityName
        //         );

        //         const allClientEntityIds =
        //             response2?.data?.[0]
        //                 ?.sort(
        //                     (a: any, b: any) =>
        //                         Number(b.clientEntityId) -
        //                         Number(a.clientEntityId)
        //                 )
        //                 ?.map(
        //                     (item: any) =>
        //                         item.clientEntityId
        //                 )
        //                 ?.join(",") || "";

        //         dispatch(
        //             setallclientEntityIds(
        //                 allClientEntityIds
        //             )
        //         );

        //         // REGION API
        //         if (
        //             clientGroupName === "ALDI" ||
        //             clientGroupName === "BLOOMS"
        //         ) {
        //             const data = `?clientEntityId=${response2.data[0][0].clientEntityId}`;

        //             const response3 =
        //                 await ApiRegionVenues(data);

        //             dispatch(setRegion(response3?.data));
        //         }
        //     }
        // }
        if ((token && userData.role.roleName === 'clientadmin') ? (userOtherData.ClientGroupName.clientGroupName === clientGroupName) : (userOtherData?.clientGroupName === clientGroupName)) {
            storage.setItem('userRole', userData.role.roleName)
            localStorage.setItem('userRole', userData.role.roleName)
            storage.setItem('userData', JSON.stringify(userData));
            storage.setItem('userOtherData', JSON.stringify(userOtherData));
            userData?.areas?.[0]?.areaId && storage.setItem('areaId', userOtherData?.areas?.[0]?.areaId)
            userOtherData?.areas?.[0]?.areaName && storage.setItem('areaName', userOtherData?.areas?.[0]?.areaName)
            userData.role.roleName !== 'clientadmin' && storage.setItem('cssNPS', userOtherData?.canClientSeeNPSScore)
            // userOtherData?.venues?.[0]?.venueName && storage.setItem('cssNPS', userOtherData?.venues?.[0]?.canClientSeeNPSScore)
            storage.setItem('INF', userOtherData?.hideFixIt);
            storage.setItem('ISC', userOtherData?.hideSiteComparison);
            userData?.role?.roleName !== 'clientadmin' && userOtherData?.clientGroupName === 'ALDI' && storage.setItem('clientEntityName', userOtherData?.clientEntityName)
            const response2 = userData?.role.roleName === 'clientadmin' && await ApiGetClientEntityId(userOtherData?.ClientID)
            response2 && storage.setItem("ratingJson", response2.data[0][0]?.ratingJson)
            const allClientEntityIds = response2?.data?.[0]
                ?.sort((a: any, b: any) => a.entityCode === "SON" ? Number(a.clientEntityId) - Number(b.clientEntityId) : Number(b.clientEntityId) - Number(a.clientEntityId))
                ?.map((item: any) => item.clientEntityId)
                ?.join(",") || "";
            dispatch(setallclientEntityIds(allClientEntityIds))
            storage.getItem('userRole') === 'clientadmin' && storage.setItem('dwc', response2.data[0][0]?.isAllowDownloadWithoutComments);
            storage.getItem('userRole') === 'clientadmin' && storage.setItem('INF', response2.data[0][0]?.hideFixIt);
            storage.getItem('userRole') === 'clientadmin' && storage.setItem('ISC', response2.data[0][0]?.hideSiteComparison);
            storage.getItem('userRole') === 'clientadmin' && storage.setItem('cssNPS', response2.data[0][0]?.canClientSeeNPSScore);
            storage.setItem('clientEntityId', userData?.role?.roleName === 'clientadmin' ? response2.data[0][0].clientEntityId : userOtherData?.clientEntityId)
            userData?.role.roleName === 'clientadmin' && storage.setItem('clientEntityName', response2.data[0][0].entityName)
            storage.setItem('ActiveTask', "Dashboard")
            navigate("/maindashboard/dashboard");
        }
        else {
            alert("Invalid Acess");
        }

        // toast.success(response.message)
        if (storage.getItem("clientEntityId") && (storage.getItem('ClientGroupName') === 'ALDI' || storage.getItem('ClientGroupName') === 'BLOOMS') && userData?.role.roleName === 'clientadmin' ? (userOtherData?.ClientGroupName.clientGroupName === clientGroupName) : (userOtherData?.clientGroupName === clientGroupName)) {
            const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            const response3 = await ApiRegionVenues(data)
            dispatch(setRegion(response3?.data))
        }

        navigate("/maindashboard/dashboard");

        return true;
    } catch (error) {
        console.log(error);
            console.log("Main Error", error);

        localStorage.clear();

        return false;
    }
};